module.exports = ".ui-autocomplete-input-token {\r\n  padding: 0px;\r\n}\r\n.ui-autocomplete-multiple-container {\r\n  width: 100%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/assets/primeng/autocomplete/css/primeng.autocomplete.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/assets/primeng/autocomplete/css/primeng.autocomplete.css
// module chunks = styles